<div
  class="form-check"
  [ngClass]="inline ? 'form-check-inline' : ''"
  *ngFor="let item of selectList | keyvalue : originalOrder"
>
  <input
    class="form-check-input"
    type="radio"
    id="inlineRadioOptions"
    [value]="item.key"
    [name]="name!"
    [formControlName]="formControlName"
    (change)="onChange(item.key)"
  />
  <label class="form-check-label">{{
    item.key | strict : strictValueKey!
  }}</label>
</div>
